<template>
  <el-select :disabled="disabled" filterable v-model="useModel" :multiple="multiple" :clearable="true" placeholder="Select" v-loading="isLoading">
    <el-option v-for="division in divisionList" :value="division.id" :label="division.name" :key="division.id">
    </el-option>
  </el-select>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  props: {
    inputModel: {
      default: 0
    },
    clearable: {
      default: false
    },
    disabled: {
      default: false
    },
    multiple: {
      default: false
    }
  },
  data () {
    return {
      divisionList: Array,
      isLoading: true,
      divInRule: {
        id: 0,
        name: 'Select All Divisions',
        isActive: true,
        isSBU: false,
        needAdminApproval: true
      }
    }
  },
  computed: {
    useModel: {
      get: function () {
        return this.inputModel
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  },
  methods: {
    fetchDivisionList () {
      this.isLoading = true
      var call = '/getPEADivisionList'
      this.$axios.get(call).then(response => {
        this.divisionList = response.data
        this.divisionList.unshift(this.divInRule)
        this.isLoading = false
      }).catch(reject => {
        this.isLoading = false
        if (this.$route.name === 'viewPEAApprovalRolesAndUsers') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent, 'Error getting Rule Division List', reject.body, 'error', 30000, '')
        } else {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent, 'Error getting Rule Division List', reject.body, 'error', 30000, '')
        }
      })
    }
  },
  created () {
    this.fetchDivisionList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
